<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="RAAS"
    >
        <rkm-form
            v-if="model"
            ref="Form"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.raas.origensPaciente"
                        :validations="validations.origemPaciente"
                        label="Origem do paciente"
                        show-default-option
                        text-field="nome"
                        v-model="model.origemPacienteId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.raas.destinosPaciente"
                        :validations="validations.destinoPaciente"
                        label="Destino do paciente"
                        show-default-option
                        text-field="nome"
                        v-model="model.destinoPacienteId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.raas.motivosSaidaPermanencia"
                        :validations="validations.motivosSaidaPermanencia"
                        label="Motivo de saída/permanência"
                        show-default-option
                        text-field="nome"
                        v-model="model.motivoSaidaPermanenciaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.raas.carateresAtendimento"
                        :validations="validations.caraterAtendimento"
                        label="Caráter do atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.caraterAtendimentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!hasProcedimentoRaasQuePrecisaDeAutorizacao"
                        :validations="validations.numeroAutorizacao"
                        label="Número da autorização"
                        number
                        v-model="model.numeroAutorizacao"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!hasProcedimentoRaasQuePrecisaDeClassificacao"
                        :options="form.raas.classificacoes"
                        :validations="validations.classificacao"
                        label="Classificação"
                        show-default-option
                        text-field="nome"
                        v-model="model.classificacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.raas.locaisRealizacaoExame"
                        :validations="validations.localRealizacaoExame"
                        label="Local de realização do exame"
                        show-default-option
                        text-field="nome"
                        v-model="model.localRealizacaoExameId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                origemPaciente: { required: true },
                destinoPaciente: { required: true },
                motivosSaidaPermanencia: { required: true },
                caraterAtendimento: { required: true },
                classificacao: { required: true },
                localRealizacaoExame: { required: true },
                numeroAutorizacao: { required: this.hasProcedimentoRaasQuePrecisaDeAutorizacao, max: 13 },
            }
        },
    },
    data: () => ({
        model: null,
        item: null,
        hasProcedimentoRaasQuePrecisaDeClassificacao: false,
        hasProcedimentoRaasQuePrecisaDeAutorizacao: false,
        enums: {procedimento},
    }),
    methods: {
        open(item) {

            this.item = item

            const codigos = [item.procedimento, ...item.procedimentos]
                .filter(procedimento => !!procedimento)
                .map(procedimento => procedimento.codigo)

            this.hasProcedimentoRaasQuePrecisaDeClassificacao = codigos
                .includes(this.enums.procedimento.ACOMPANHAMENTO_DE_PACIENTE_EM_SAUDE_MENTAL)

            this.hasProcedimentoRaasQuePrecisaDeAutorizacao = codigos.some(codigo => [
                this.enums.procedimento.ACOMPANHAMENTO_DE_PACIENTE_EM_SAUDE_MENTAL,
                this.enums.procedimento.ACOMPANHAMENTO_DE_PESSOAS_COM_NECESSIDADES_DECORRENTES_DO_USO_DE_ALCOOL_CRACK_E_OUTRAS_DROGAS,
                this.enums.procedimento.ACOMPANHAMENTO_DE_PESSOAS_ADULTAS_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS,
                this.enums.procedimento.ACOMPANHAMENTO_DA_POPULACAO_INFANTO_JUVENIL_COM_SOFRIMENTO_OU_TRANSTORNOS_MENTAIS_DECORRENTES_DO_USO_DE_CRACK_ALCOOL_E_OUTRAS_DROGAS,
            ].includes(codigo))

            this.model = this.clone(item.raas)

            this.$refs.RkmModal.show()
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.item.raas = this.clone(this.model)

                    this.$refs.RkmModal.hide()
                })
        }
    },
    mixins: [object],
    props: {
        form: {type: Object, required: true},
    },
}
</script>
